import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as H } from "./index.es2359.js";
function i({ size: V = H }) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: V,
      height: V,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M26.8 28V31.6C26.8 33.589 28.411 35.2 30.4 35.2C31.6516 35.2 32.7546 34.5611 33.3997 33.5912C34.0445 34.5611 35.1472 35.2 36.3998 35.2C38.3873 35.2 39.9998 33.589 39.9998 31.6V28H26.8Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M15.9998 16H29.3001V19.6C29.3001 21.589 27.6891 23.2 25.7001 23.2C24.4153 23.2 23.2872 22.5268 22.6501 21.5134C22.0133 22.5268 20.8855 23.2 19.5998 23.2C17.6123 23.2 15.9998 21.589 15.9998 19.6V16Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M27.9995 34.2834C28.6364 34.8535 29.4776 35.2 30.4 35.2C31.6517 35.2 32.7546 34.5611 33.3997 33.5912C34.0445 34.5611 35.1472 35.2 36.3998 35.2C38.3718 35.2 39.9746 33.614 39.9995 31.6465V40H30.323C29.039 40 27.9995 38.9605 27.9995 37.6765V34.2834Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M17 22.0903V27H27V22.9584C26.5968 23.1144 26.1585 23.2 25.7001 23.2C24.4153 23.2 23.2872 22.5268 22.6501 21.5134C22.0133 22.5268 20.8855 23.2 19.5998 23.2C18.578 23.2 17.6554 22.7742 17 22.0903Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.9998 16H29.3001V19.6C29.3001 20.7143 28.7945 21.71 28 22.3702V25.6765C28 26.9605 26.9605 28 25.6765 28H16V19.6424L15.9998 19.6V16ZM25.7001 23.2C26.1585 23.2 26.5968 23.1144 27 22.9584V25.6765C27 26.4082 26.4082 27 25.6765 27H24.1002V25.1344C24.1002 24.7294 23.7717 24.3994 23.3652 24.3994H21.2352C20.8287 24.3994 20.5002 24.7294 20.5002 25.1344V27H17V22.0903C17.6554 22.7743 18.578 23.2 19.5998 23.2C20.8855 23.2 22.0133 22.5268 22.6501 21.5134C23.2872 22.5268 24.4153 23.2 25.7001 23.2ZM22.1417 20.1492C22.1143 19.9702 22.1001 19.7868 22.1001 19.6V17H16.9998V19.6C16.9998 21.0364 18.1643 22.2 19.5998 22.2C20.848 22.2 21.8899 21.3219 22.1417 20.1492ZM23.1001 17H28.3001V19.6C28.3001 21.0367 27.1368 22.2 25.7001 22.2C24.2646 22.2 23.1001 21.0364 23.1001 19.6V17ZM21.5002 26.9994V25.3994H23.1002V26.9994H21.5002Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C("path", { d: "M31 20.25H36.126V26.5H37.126V19.25H31V20.25Z", fill: "#5E63E5" }),
        /* @__PURE__ */ C("path", { d: "M20.0996 29.5V37.25H26.4509V38.25H19.0996V29.5H20.0996Z", fill: "#5E63E5" }),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M26.8 31.6V28H39.9998V31.6C39.9998 33.589 38.3873 35.2 36.3998 35.2C35.1472 35.2 34.0445 34.5611 33.3997 33.5912C32.7546 34.5611 31.6517 35.2 30.4 35.2C29.9028 35.2 29.4292 35.0993 28.9984 34.9172L28.9995 34.9177V37.6765C28.9995 38.4082 29.5913 39 30.323 39H31.8992V37.1344C31.8992 36.7294 32.2277 36.3994 32.6342 36.3994H34.7642C35.1707 36.3994 35.4992 36.7294 35.4992 37.1344V39H38.9995V34.0903C39.6091 33.4542 39.9875 32.5946 39.9995 31.6465V40H30.323C29.039 40 27.9995 38.9605 27.9995 37.6765V34.2834C27.2632 33.6243 26.8 32.6665 26.8 31.6ZM27.8 29H32.7998V31.6C32.7998 31.8656 32.8285 32.1245 32.883 32.3737C32.5536 33.432 31.5663 34.2 30.4 34.2C28.9633 34.2 27.8 33.0367 27.8 31.6V29ZM33.7998 29H38.9998V31.6C38.9998 33.0364 37.8352 34.2 36.3998 34.2C34.963 34.2 33.7998 33.0367 33.7998 31.6V29ZM34.4992 37.3994V38.9994H32.8992V37.3994H34.4992Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
i.__tags = [];
export {
  i as MetricVenuesIcon
};
//# sourceMappingURL=index.es412.js.map
